module.exports = __webpack_public_path__ + "img/chat_popup.d399859d.svg";